import { Injectable } from "@angular/core";
import { CommonService } from "../services/common.service";

/* GOOGLE ANALYTICS */
declare var gtag: any;
declare var ytag: any;

@Injectable({
  providedIn: "root",
})
export class EmbedCodeService {
  public moment: any;

  constructor(public commonService: CommonService) {
    this.moment = this.commonService.getMoment();
  }

  async init() {}

  /* Google Tag Manager BELOW */
  googleTagHomeHeaderSet() {
    /* Event snippet for マイクロCV conversion page */
    // gtag("event", "conversion", {
    //   send_to: "AW-836579082/eWIkCIDD4KkBEIre9I4D",
    // });
  }

  googleTagReservationFinishHeaderSet(data: any = {}) {
    /* Event snippet for 予約 conversion page */
    // gtag("event", "conversion", {
    //   send_to: "AW-836579082/JAoMCPSehnUQit70jgM",
    //   value: data.price,
    //   currency: "JPY",
    // });
  }
  /* END */

  /* Yahoo Tag Manager BELOW */
  yahooTagReservationFinishHeaderSet(data: any = {}) {
    // ytag({ type: "ycl_cookie" });
    //
    // ytag({
    //   type: "yss_conversion",
    //   config: {
    //     yahoo_conversion_id: "1000402641",
    //     yahoo_conversion_label: "cPj4CMWgsXQQi5r1jgM",
    //     yahoo_conversion_value: data.price,
    //   },
    // });
  }

  /* ALL PAGES BODY */
  yahooTagBodySet() {
    // ytag({
    //   type: "yss_retargeting",
    //   config: {
    //     yahoo_ss_retargeting_id: "1000402641",
    //     yahoo_sstag_custom_params: {},
    //   },
    // });
    //
    // ytag({
    //   type: "yjad_retargeting",
    //   config: {
    //     yahoo_retargeting_id: "G1U5TGW3GA",
    //     yahoo_retargeting_label: "",
    //     yahoo_retargeting_page_type: "",
    //     yahoo_retargeting_items: [
    //       { item_id: "i1", category_id: "", price: "", quantity: "" },
    //       { item_id: "i2", category_id: "", price: "", quantity: "" },
    //       { item_id: "i3", category_id: "", price: "", quantity: "" },
    //     ],
    //   },
    // });
  }
  /* END */

  /* LCL tags BELOW */
  lclTagReservationFinishHeaderSet(data: any = {}) {
    return `
            <!-- LCL tags 20191224 -->

            <img src="http://af.lclco.com/track.php?t=abcdefg&p=5239352542dba&guid=ON&price=${
              data.price
            }&p1=${data.reservationID}&p2=${data.departureDate}&p3=${
      data.men
    }&p4=${data.women}&p5=${data.totalPeople}&p6=${data.age}&p9=${
      data.planCode
    }&p10=${data.planName}&p13=${data.children}&p14=${data.infant}&p15=${
      data.paymentMethod
    }&p16=${data.departureName}&p17=${data.destinationName}&p20=${
      data.job
    }&p21=${data.customerCity}&p22=${data.quantity}&p23=${data.platform}&p25=${
      !this.commonService.isProduction() ? "TEST-" + data.memo : ""
    }" width="1"height="1" style="display: none;" />

            <!-- //LCL tags 20191224 -->
        `;
  }
  /* END */

  /* A8 tags */
  /* data AS FINISHED RESERVATION DATA */
  a8TagReservationFinishHeaderSet(finishData: any = {}) {
    let orderNumbers: any = [];
    let items = [];

    for (let item of finishData.reservation_list) {
      orderNumbers.push(item.reservation_id);
      orderNumbers.push(this.moment(item.dpt_ymd).format("YYYYMMDD"));

      items.push({
        code: item.bus_code,
        price: item.price_taxin,
        quantity: 1,
      });
    }

    return `
            <span id="a8sales"></span>
            <script src="//statics.a8.net/a8sales/a8sales.js"></script>
            <script>
                setTimeout(function() {
                    $(document).ready(function() {
                        a8sales({
                            "pid": "${
                              this.commonService.isProduction()
                                ? this.commonService.appConfig.embedCode.a8.pid
                                : this.commonService.appConfig.embedCode.a8
                                    .pidTest
                            }",
                            "order_number": "${orderNumbers.join("-")}",
                            "currency": "JPY",
                            "total_price": "${finishData.total_price}",
                            "items": ${JSON.stringify(items)},
                        });
                    });
                }, 1500);
            </script>
        `;
  }
  /* END */

  /* AFB tags */
  afbTagReservationFinishHeaderSet(finishData: any = {}, cartData: any = {}) {
    const siteUserID = finishData.reservation_list
      .map((x) => x.reservation_id)
      .join("-");
    const amount = cartData
      .flatMap((x) => [
        {
          code: x.plan.plan_code,
          num: x.passenger.adult.total,
          price: x.plan.price,
        },
        {
          code: x.plan.plan_code,
          num: x.passenger.children.total,
          price: x.plan.price_child,
        },
      ])
      .filter((x) => x.num > 0)
      .map((x) => `${x.code}.${x.num}.${x.price}`)
      .join(":");

    return `
            <script>
                if (!window.afblpcvCvConf) {
                    window.afblpcvCvConf = [];
                }
                window.afblpcvCvConf.push({
                    siteId: "bb9a2f49",
                    commitData: {
                    pid: "H124399",
                    u: "${siteUserID}",
                    amount: "${amount}"
                    }
                });
            </script>
            <script src="https://t.afi-b.com/jslib/lpcv.js?cid=bb9a2f49&pid=H124399" async="async"></script>
        `;
  }
  /* END */

  /* ARI tags */
  ariTagReservationFinishHeaderSet(finishData: any = {}, cartData: any = {}) {
    const productCode = finishData.reservation_list
      .map((x) => x.reservation_id)
      .join("-");
    const amount = cartData.map((x) => x.totalPrice).reduce((a, b) => a + b, 0);

    return `
            <script>
                if (!window.arigConf) { window.arigConf = []; }
                window.arigConf.push({
                    ct: "5z7uxkcimask4kk0wow8",
                    amount: "${amount}",
                    productCode: "${productCode}"
                });
            </script>
            <script src="https://cro.fi-tsunagu.com/assets/ari/js/arig.js" async="async"></script>
        `;
  }
  /* END */
}
